import React from 'react';
import PropTypes from 'prop-types';

import { snakeCase } from 'lodash';
import withMessages from 'component-utilities/intl';

import styles from '../Flags.scss';

export default function FlagGenerator(type) {
    function FlagGeneratorComponent({ getMessage }) {
        return (<span className={styles[`flag-${type}`]}>
            {getMessage(`components.flags.${snakeCase(type)}`)}
        </span>)
    }

    FlagGeneratorComponent.propTypes = {
        getMessage: PropTypes.func.isRequired,
    };

    const Flag = withMessages(FlagGeneratorComponent);

    return Flag;
}
